import {
  TBgEventsSyncingDBLockDetails,
  TRESPONSE_VendorsResponse,
  TUserActualsDBLockDetails,
  TBulkCountAppBackgroundDB,
  TBulkWashingEventType,
  TBulkCountSyncEventsDTO,
  TRESPONSE_BusinessContextData,
  TBulkCountAppUserActualsDB,
  TRESPONSE_BulkWashSentQuantityResponse,
  TRESPONSE_WipByBctxResponse,
  TRESPONSE_WashingReceiveBctxDataResponse,
  TBulkGradingPageSizeItem,
  TBctxItemWithoutSize,
  TVendorDTO,
  TBulkWashingSyncedTransactions,
  TBulkCountUserAction,
  TBulkCountPendingTransactionWithBctxList,
  TBulkCountClientDBInitInfo,
  TWashingUndoTransactionDetail,
} from '@monorepo/types';
import { Action } from '@ngrx/store';

export enum BulkCountAppDBActionTypes {
  AcquireLockAndThenInitializeAllDBs = '[BULK_APP_COUNT_DB] AcquireLockAndThenInitializeAllDBs',
  InitializeAllDBsAndThenReleaseLock = '[BULK_APP_COUNT_DB] InitializeAllDBsAndThenReleaseLock',
  SetUserDBAndBackgoundDBAndReleaseLock = '[BULK_APP_COUNT_DB] SetUserDBAndBackgoundDBAndReleaseLock',
  SetUserAndBgDBAndReleaseLockAndThenAcquireLockAndThenSyncStyleInfo = '[BULK_APP_COUNT_DB] SetUserAndBgDBAndReleaseLockAndThenAcquireLockAndThenSyncStyleInfo',
  SetUserAndBgDBAndReleaseLockAndThenAcquireLockAndThenSyncReceiveCount = '[BULK_APP_COUNT_DB] SetUserAndBgDBAndReleaseLockAndThenAcquireLockAndThenSyncReceiveCount',
  ReleaseUserDBLock = '[BULK_APP_COUNT_DB] ReleaseUserDBLock',
  ReleaseBgDBLock = '[BULK_APP_COUNT_DB] ReleaseBgDBLock',
  UpdateLockDetails = '[BULK_APP_COUNT_DB] UpdateLockDetails',
  UpdateBgDBLockDetails = '[BULK_APP_COUNT_DB] UpdateBgDBLockDetails',
  AcquireBgDBLockAndThenSyncEvents = '[BULK_APP_COUNT_DB] AcquireBgDBLockAndThenSyncEvents',
  AcquireUserAndBgDBLockAndThenReconcileForWashing = 'AcquireUserAndBgDBLockAndThenReconcileForWashing',
  ReconcileUserDBAndBgDBAndThenReleaseLocksForWashing = 'ReconcileUserDBAndBgDBAndThenReleaseLocksForWashing',
  SetUserDBAndBgDBAndReleaseLocksWithChainsForWashing = 'SetUserDBAndBgDBAndReleaseLocksWithChainsForWashing',
  SyncEventsAndThenReleaseBgDBLock = '[BULK_APP_COUNT_DB] SyncEventsAndThenReleaseBgDBLock',
  UpdateBulkCountAppBackgroundDB = '[BULK_APP_COUNT_DB] UpdateBulkCountAppBackgroundDB',
  UpdateBgDBAndReleaseLockForSyncEvents = '[BULK_APP_COUNT_DB] UpdateBgDBAndReleaseLockForSyncEvents',
  AcquireUserDBLockAndSyncWashingInStyleInfo = '[BULK_APP_COUNT_DB] AcquireUserDBLockAndSyncWashingInStyleInfo',
  SyncStyleInfoAndThenReleaseUserDBLock = '[BULK_APP_COUNT_DB] SyncStyleInfoAndThenReleaseUserDBLock',
  SyncStyleInfoSuccessAndThenReleaseLock = '[BULK_APP_COUNT_DB] SyncStyleInfoSuccessAndThenReleaseLock',
  UpdateUserDBAndSyncSendCountAndThenReleaseLock = '[BULK_APP_COUNT_DB] UpdateUserDBAndSyncSendCountAndThenReleaseLock',
  SyncSendCountSuccessAndThenReleaseLock = '[BULK_APP_COUNT_DB] SyncSendCountSuccessAndThenReleaseLock',
  UpdateUserDBAndSyncBctxWiseSentQuantityAndThenReleaseLock = '[BULK_APP_COUNT_DB] UpdateUserDBAndSyncBctxWiseSentQuantityAndThenReleaseLock',
  SyncBctxWiseSentQuantitySuccessAndThenReleaseLock = '[BULK_APP_COUNT_DB] SyncBctxWiseSentQuantitySuccessAndThenReleaseLock',
  UpdatedUserDBAndSyncBctxWiseWipQuantityAndThenReleaseLock = '[BULK_APP_COUNT_DB] UpdatedUserDBAndSyncBctxWiseWipQuantityAndThenReleaseLock',
  SyncBctxWiseWipQuantitySuccessAndThenReleaseLock = '[BULK_APP_COUNT_DB] SyncBctxWiseWipQuantitySuccessAndThenReleaseLock',
  UpdateUserDBAndReleaseLock = '[BULK_APP_COUNT_DB] UpdateUserDBAndReleaseLock',
  SetInitialVendorsDBAndSyncVendors = 'SetInitialVendorsDBAndSyncVendors',
  SyncVendors = 'SyncVendors',
  InitVendorDB = 'InitVendorDB',
  UpdateVendorsDetails = '[BULK_APP_COUNT_DB] UpdateVendorsDetails',
  AcquireUserDBLockAndThenSyncReceiveCount = '[BULK_APP_COUNT_DB] AcquireUserDBLockAndThenSyncReceiveCount',
  SyncReceiveCountAndThenReleaseLock = '[BULK_APP_COUNT_DB] SyncReceiveCountAndThenReleaseLock',
  SyncReceiveCountSuccessAndThenReleaseLock = '[BULK_APP_COUNT_DB] SyncReceiveCountSuccessAndThenReleaseLock',
  UpdateUserDBAndSyncVendorsToBctxCombinationDataAndThenReleaseLock = '[BULK_APP_COUNT_DB] UpdateUserDBAndSyncVendorsToBctxCombinationDataAndThenReleaseLock',
  SyncVendorsToBctxCombinationDataSuccessAndThenReleaseLock = '[BULK_APP_COUNT_DB] SyncVendorsToBctxCombinationDataSuccessAndThenReleaseLock',
  AcquireUserDBLockAndSavePendingWork = '[BULK_APP_COUNT_DB] AcquireUserDBLockAndSavePendingWork',
  AcquireUserDBLockAndRemoveTransaction = 'AcquireUserDBLockAndRemoveTransaction',
  RemoveTransactionAndThenReleaseLock = 'RemoveTransactionAndThenReleaseLock',
  AcquireUserDBLockAndUpdatePendingWork = 'AcquireUserDBLockAndUpdatePendingWork',
  SavePendingWorkAndThenReleaseLock = '[BULK_APP_COUNT_DB] SavePendingWorkAndThenReleaseLock',
  UpdatePendingWorkAndThenReleaseLock = 'UpdatePendingWorkAndThenReleaseLock',
  UpdateUserDBAndReleaseLockAndThenRedirectToLandingPage = '[BULK_APP_COUNT_DB] UpdateUserDBAndReleaseLockAndThenRedirectToLandingPage',
  AcquireUserDBLockAndSaveEvent = '[BULK_APP_COUNT_DB] AcquireUserDBLockAndSaveEvent',
  SaveSendEventkAndThenReleaseLock = '[BULK_APP_COUNT_DB] SaveSendEventkAndThenReleaseLock',
  SaveReceiveEventkAndThenReleaseLock = '[BULK_APP_COUNT_DB] SaveReceiveEventkAndThenReleaseLock',
  UpdateUserDBAndReleaseLockAndSynEventsAndRedirectToLandingPage = '[BULK_APP_COUNT_DB] UpdateUserDBAndReleaseLockAndSynEventsAndRedirectToLandingPage',
  AcquireUserDBLockAndThenSyncTransactions = '[BULK_APP_COUNT_DB] AcquireUserDBLockAndThenSyncTransactions',
  SyncSendTransactionsAndThenReleaseLock = '[BULK_APP_COUNT_DB] SyncSendTransactionsAndThenReleaseLock',
  SyncReceiveTransactionsAndThenReleaseLock = '[BULK_APP_COUNT_DB] SyncReceiveTransactionsAndThenReleaseLock',
  SyncTransactionsSuccessAndThenReleaseLock = '[BULK_APP_COUNT_DB] SyncTransactionsSuccessAndThenReleaseLock',
  CheckStationOrShiftChange = '[BULK_APP_COUNT_DB] CheckStationOrShiftChange',
  AcquireUserDBLockAndUndoWashingSendEvent = '[BULK_APP_COUNT_DB] AcquireUserDBLockAndUndoWashingSendEvent',
  AcquireUserDBLockAndUndoWashingReceiveEvent = '[BULK_APP_COUNT_DB] AcquireUserDBLockAndUndoWashingReceiveEvent',
  BulkCountAppNoAction = '[BULK_APP_COUNT_DB] Bulk count app no action',
}

export class AcquireLockAndThenInitializeAllDBs implements Action {
  readonly type = BulkCountAppDBActionTypes.AcquireLockAndThenInitializeAllDBs;
  constructor(public bulkWashingEventType: TBulkWashingEventType) {}
}
export class InitializeAllDBsAndThenReleaseLock implements Action {
  readonly type = BulkCountAppDBActionTypes.InitializeAllDBsAndThenReleaseLock;
  constructor(public bulkWashingEventType: TBulkWashingEventType) {}
}

export class SetUserDBAndBackgoundDBAndReleaseLock implements Action {
  readonly type = BulkCountAppDBActionTypes.SetUserDBAndBackgoundDBAndReleaseLock;
  constructor(public userActualDB: TBulkCountAppUserActualsDB, public backgroundDB: TBulkCountAppBackgroundDB) {}
}

export class SetUserAndBgDBAndReleaseLockAndThenAcquireLockAndThenSyncStyleInfo implements Action {
  readonly type = BulkCountAppDBActionTypes.SetUserAndBgDBAndReleaseLockAndThenAcquireLockAndThenSyncStyleInfo;
  constructor(
    public userActualDB: TBulkCountAppUserActualsDB,
    public backgroundDB: TBulkCountAppBackgroundDB,
    public initInfo: TBulkCountClientDBInitInfo,
  ) {}
}

export class SetUserAndBgDBAndReleaseLockAndThenAcquireLockAndThenSyncReceiveCount implements Action {
  readonly type = BulkCountAppDBActionTypes.SetUserAndBgDBAndReleaseLockAndThenAcquireLockAndThenSyncReceiveCount;
  constructor(
    public userActualDB: TBulkCountAppUserActualsDB,
    public backgroundDB: TBulkCountAppBackgroundDB,
    public initInfo: TBulkCountClientDBInitInfo,
  ) {}
}
export class ReleaseUserDBLock implements Action {
  readonly type = BulkCountAppDBActionTypes.ReleaseUserDBLock;
  constructor() {}
}
export class ReleaseBgDBLock implements Action {
  readonly type = BulkCountAppDBActionTypes.ReleaseBgDBLock;
  constructor() {}
}
export class UpdateLockDetails implements Action {
  readonly type = BulkCountAppDBActionTypes.UpdateLockDetails;
  constructor(public lockDetails: TUserActualsDBLockDetails) {}
}
export class UpdateBgDBLockDetails implements Action {
  readonly type = BulkCountAppDBActionTypes.UpdateBgDBLockDetails;
  constructor(public lockDetails: TBgEventsSyncingDBLockDetails) {}
}

/** bulk washing send initialization actions */
export class AcquireUserDBLockAndSyncWashingInStyleInfo implements Action {
  readonly type = BulkCountAppDBActionTypes.AcquireUserDBLockAndSyncWashingInStyleInfo;
  constructor() {}
}
export class SyncStyleInfoAndThenReleaseUserDBLock implements Action {
  readonly type = BulkCountAppDBActionTypes.SyncStyleInfoAndThenReleaseUserDBLock;
  constructor() {}
}

export class SyncStyleInfoSuccessAndThenReleaseLock implements Action {
  readonly type = BulkCountAppDBActionTypes.SyncStyleInfoSuccessAndThenReleaseLock;
  constructor(public businessContextData: TRESPONSE_BusinessContextData) {}
}

export class UpdateUserDBAndSyncSendCountAndThenReleaseLock implements Action {
  readonly type = BulkCountAppDBActionTypes.UpdateUserDBAndSyncSendCountAndThenReleaseLock;
  constructor(public currentDB: TBulkCountAppUserActualsDB) {}
}

export class SyncSendCountSuccessAndThenReleaseLock implements Action {
  readonly type = BulkCountAppDBActionTypes.SyncSendCountSuccessAndThenReleaseLock;
  constructor(public sentCount: number) {}
}

export class UpdateUserDBAndSyncBctxWiseSentQuantityAndThenReleaseLock implements Action {
  readonly type = BulkCountAppDBActionTypes.UpdateUserDBAndSyncBctxWiseSentQuantityAndThenReleaseLock;
  constructor(public currentDB: TBulkCountAppUserActualsDB) {}
}

export class SyncBctxWiseSentQuantitySuccessAndThenReleaseLock implements Action {
  readonly type = BulkCountAppDBActionTypes.SyncBctxWiseSentQuantitySuccessAndThenReleaseLock;
  constructor(public res: TRESPONSE_BulkWashSentQuantityResponse) {}
}
export class UpdatedUserDBAndSyncBctxWiseWipQuantityAndThenReleaseLock implements Action {
  readonly type = BulkCountAppDBActionTypes.UpdatedUserDBAndSyncBctxWiseWipQuantityAndThenReleaseLock;
  constructor(public currentDB: TBulkCountAppUserActualsDB) {}
}
export class SyncBctxWiseWipQuantitySuccessAndThenReleaseLock implements Action {
  readonly type = BulkCountAppDBActionTypes.SyncBctxWiseWipQuantitySuccessAndThenReleaseLock;
  constructor(public res: TRESPONSE_WipByBctxResponse) {}
}

export class UpdateUserDBAndReleaseLock implements Action {
  readonly type = BulkCountAppDBActionTypes.UpdateUserDBAndReleaseLock;
  constructor(public currentDB: TBulkCountAppUserActualsDB) {}
}
export class InitVendorDB implements Action {
  readonly type = BulkCountAppDBActionTypes.InitVendorDB;
  constructor() {}
}
export class SetInitialVendorsDBAndSyncVendors implements Action {
  readonly type = BulkCountAppDBActionTypes.SetInitialVendorsDBAndSyncVendors;
  constructor(public res: TRESPONSE_VendorsResponse) {}
}
export class SyncVendors implements Action {
  readonly type = BulkCountAppDBActionTypes.SyncVendors;
  constructor(public showLoader: boolean) {}
}
export class UpdateVendorsDetails implements Action {
  readonly type = BulkCountAppDBActionTypes.UpdateVendorsDetails;
  constructor(public res: TRESPONSE_VendorsResponse) {}
}

/** bulk washing receive initialization actions */
export class AcquireUserDBLockAndThenSyncReceiveCount implements Action {
  readonly type = BulkCountAppDBActionTypes.AcquireUserDBLockAndThenSyncReceiveCount;
  constructor() {}
}
export class SyncReceiveCountAndThenReleaseLock implements Action {
  readonly type = BulkCountAppDBActionTypes.SyncReceiveCountAndThenReleaseLock;
  constructor() {}
}
export class SyncReceiveCountSuccessAndThenReleaseLock implements Action {
  readonly type = BulkCountAppDBActionTypes.SyncReceiveCountSuccessAndThenReleaseLock;
  constructor(public receiveCount: number) {}
}
export class UpdateUserDBAndSyncVendorsToBctxCombinationDataAndThenReleaseLock implements Action {
  readonly type = BulkCountAppDBActionTypes.UpdateUserDBAndSyncVendorsToBctxCombinationDataAndThenReleaseLock;
  constructor(public currentDB: TBulkCountAppUserActualsDB) {}
}

export class SyncVendorsToBctxCombinationDataSuccessAndThenReleaseLock implements Action {
  readonly type = BulkCountAppDBActionTypes.SyncVendorsToBctxCombinationDataSuccessAndThenReleaseLock;
  constructor(public res: TRESPONSE_WashingReceiveBctxDataResponse) {}
}

/**  User working actions*/
export class AcquireUserDBLockAndUpdatePendingWork implements Action {
  readonly type = BulkCountAppDBActionTypes.AcquireUserDBLockAndUpdatePendingWork;
  constructor(
    public eventType: TBulkWashingEventType,
    public bctxList: TBctxItemWithoutSize[],
    public vendorId: TVendorDTO['vendorId'] | undefined,
    public updatedSavedQty: Record<string, number>,
  ) {}
}
export class UpdatePendingWorkAndThenReleaseLock implements Action {
  readonly type = BulkCountAppDBActionTypes.UpdatePendingWorkAndThenReleaseLock;
  constructor(
    public eventType: TBulkWashingEventType,
    public bctxList: TBctxItemWithoutSize[],
    public vendorId: TVendorDTO['vendorId'] | undefined,
    public updatedSavedQty: Record<string, number>,
  ) {}
}
export class AcquireUserDBLockAndRemoveTransaction implements Action {
  readonly type = BulkCountAppDBActionTypes.AcquireUserDBLockAndRemoveTransaction;
  constructor(public details: TBulkCountPendingTransactionWithBctxList) {}
}

export class RemoveTransactionAndThenReleaseLock implements Action {
  readonly type = BulkCountAppDBActionTypes.RemoveTransactionAndThenReleaseLock;
  constructor(public details: TBulkCountPendingTransactionWithBctxList) {}
}
export class AcquireUserDBLockAndSavePendingWork implements Action {
  readonly type = BulkCountAppDBActionTypes.AcquireUserDBLockAndSavePendingWork;
  constructor(
    public eventType: TBulkWashingEventType,
    public bctxList: TBctxItemWithoutSize[],
    public sizeList: TBulkGradingPageSizeItem[],
    public vendorId: TVendorDTO['vendorId'] | undefined,
  ) {}
}
export class SavePendingWorkAndThenReleaseLock implements Action {
  readonly type = BulkCountAppDBActionTypes.SavePendingWorkAndThenReleaseLock;
  constructor(
    public eventType: TBulkWashingEventType,
    public bctxList: TBctxItemWithoutSize[],
    public sizeList: TBulkGradingPageSizeItem[],
    public vendorId: TVendorDTO['vendorId'] | undefined,
  ) {}
}
export class UpdateUserDBAndReleaseLockAndThenRedirectToLandingPage implements Action {
  readonly type = BulkCountAppDBActionTypes.UpdateUserDBAndReleaseLockAndThenRedirectToLandingPage;
  constructor(public eventType: TBulkWashingEventType, public currentDB: TBulkCountAppUserActualsDB) {}
}

/** */
export class AcquireUserDBLockAndSaveEvent implements Action {
  readonly type = BulkCountAppDBActionTypes.AcquireUserDBLockAndSaveEvent;
  constructor(
    public eventType: TBulkWashingEventType,
    public bctxList: TBctxItemWithoutSize[],
    public sizeList: TBulkGradingPageSizeItem[],
    public vendorId: TVendorDTO['vendorId'],
  ) {}
}
export class SaveSendEventkAndThenReleaseLock implements Action {
  readonly type = BulkCountAppDBActionTypes.SaveSendEventkAndThenReleaseLock;
  constructor(
    public bctxList: TBctxItemWithoutSize[],
    public sizeList: TBulkGradingPageSizeItem[],
    public vendorId: TVendorDTO['vendorId'],
  ) {}
}
export class SaveReceiveEventkAndThenReleaseLock implements Action {
  readonly type = BulkCountAppDBActionTypes.SaveReceiveEventkAndThenReleaseLock;
  constructor(
    public bctxList: TBctxItemWithoutSize[],
    public sizeList: TBulkGradingPageSizeItem[],
    public vendorId: TVendorDTO['vendorId'],
  ) {}
}
export class UpdateUserDBAndReleaseLockAndSynEventsAndRedirectToLandingPage implements Action {
  readonly type = BulkCountAppDBActionTypes.UpdateUserDBAndReleaseLockAndSynEventsAndRedirectToLandingPage;
  constructor(public eventType: TBulkWashingEventType, public currentDB: TBulkCountAppUserActualsDB) {}
}
export class AcquireUserDBLockAndThenSyncTransactions implements Action {
  readonly type = BulkCountAppDBActionTypes.AcquireUserDBLockAndThenSyncTransactions;
  constructor(public eventType: TBulkWashingEventType, public startTime: number, public endTime: number) {}
}
export class SyncSendTransactionsAndThenReleaseLock implements Action {
  readonly type = BulkCountAppDBActionTypes.SyncSendTransactionsAndThenReleaseLock;
  constructor(public startTime: number, public endTime: number) {}
}
export class SyncReceiveTransactionsAndThenReleaseLock implements Action {
  readonly type = BulkCountAppDBActionTypes.SyncReceiveTransactionsAndThenReleaseLock;
  constructor(public startTime: number, public endTime: number) {}
}
export class SyncTransactionsSuccessAndThenReleaseLock implements Action {
  readonly type = BulkCountAppDBActionTypes.SyncTransactionsSuccessAndThenReleaseLock;
  constructor(public res: TBulkWashingSyncedTransactions) {}
}

export class AcquireUserAndBgDBLockAndThenReconcileForWashing implements Action {
  readonly type = BulkCountAppDBActionTypes.AcquireUserAndBgDBLockAndThenReconcileForWashing;
  constructor(
    public showLockFailure: boolean,
    public chainAction: TBulkCountUserAction,
    public eventType: TBulkWashingEventType,
  ) {}
}
export class ReconcileUserDBAndBgDBAndThenReleaseLocksForWashing implements Action {
  readonly type = BulkCountAppDBActionTypes.ReconcileUserDBAndBgDBAndThenReleaseLocksForWashing;
  constructor(public chainAction: TBulkCountUserAction, public eventType: TBulkWashingEventType) {}
}

export class SetUserDBAndBgDBAndReleaseLocksWithChainsForWashing implements Action {
  readonly type = BulkCountAppDBActionTypes.SetUserDBAndBgDBAndReleaseLocksWithChainsForWashing;
  constructor(
    public userActualDB: TBulkCountAppUserActualsDB,
    public backgroundDB: TBulkCountAppBackgroundDB,
    public chainAction: TBulkCountUserAction,
    public eventType: TBulkWashingEventType,
  ) {}
}

/** BACKGROUND DB ACTIONS */
export class AcquireBgDBLockAndThenSyncEvents implements Action {
  readonly type = BulkCountAppDBActionTypes.AcquireBgDBLockAndThenSyncEvents;
  constructor(
    public showLockFailure: boolean,
    public batchCount: number,
    public eventType: TBulkWashingEventType,
    public chainAction?: TBulkCountUserAction,
  ) {}
}
export class SyncEventsAndThenReleaseBgDBLock implements Action {
  readonly type = BulkCountAppDBActionTypes.SyncEventsAndThenReleaseBgDBLock;
  constructor(
    public showLoader: boolean,
    public batchCount: number,
    public eventType: TBulkWashingEventType,
    public chainAction?: TBulkCountUserAction,
  ) {}
}
export class UpdateBulkCountAppBackgroundDB implements Action {
  readonly type = BulkCountAppDBActionTypes.UpdateBulkCountAppBackgroundDB;
  constructor(public bulkCountAppBackgroundDB: TBulkCountAppBackgroundDB) {}
}
export class UpdateBgDBAndReleaseLockForSyncEvents implements Action {
  readonly type = BulkCountAppDBActionTypes.UpdateBgDBAndReleaseLockForSyncEvents;
  constructor(
    public pastEventsSynced: boolean,
    public currentDB: TBulkCountAppBackgroundDB,
    public syncEventsDTO: TBulkCountSyncEventsDTO,
    public eventType: TBulkWashingEventType,
    public chainAction?: TBulkCountUserAction,
  ) {}
}
export class CheckStationOrShiftChange implements Action {
  readonly type = BulkCountAppDBActionTypes.CheckStationOrShiftChange;
  constructor() {}
}

export class AcquireUserDBLockAndUndoWashingSendEvent implements Action {
  readonly type = BulkCountAppDBActionTypes.AcquireUserDBLockAndUndoWashingSendEvent;
  constructor(public payload: TWashingUndoTransactionDetail, public startTime: number, public endTime: number) {}
}
export class AcquireUserDBLockAndUndoWashingReceiveEvent implements Action {
  readonly type = BulkCountAppDBActionTypes.AcquireUserDBLockAndUndoWashingReceiveEvent;
  constructor(public payload: TWashingUndoTransactionDetail, public startTime: number, public endTime: number) {}
}
export class BulkCountAppNoAction implements Action {
  readonly type = BulkCountAppDBActionTypes.BulkCountAppNoAction;
  constructor() {}
}

export type TBulkCountAppActions =
  | AcquireLockAndThenInitializeAllDBs
  | InitializeAllDBsAndThenReleaseLock
  | SetUserDBAndBackgoundDBAndReleaseLock
  /***/
  | SetUserAndBgDBAndReleaseLockAndThenAcquireLockAndThenSyncStyleInfo
  | AcquireUserDBLockAndSyncWashingInStyleInfo
  | SyncStyleInfoAndThenReleaseUserDBLock
  | SyncStyleInfoSuccessAndThenReleaseLock
  | UpdateUserDBAndSyncSendCountAndThenReleaseLock
  | UpdateUserDBAndSyncBctxWiseSentQuantityAndThenReleaseLock
  | SyncBctxWiseSentQuantitySuccessAndThenReleaseLock
  | UpdatedUserDBAndSyncBctxWiseWipQuantityAndThenReleaseLock
  | SyncBctxWiseWipQuantitySuccessAndThenReleaseLock
  | UpdateUserDBAndReleaseLock
  | UpdateVendorsDetails
  | SetInitialVendorsDBAndSyncVendors
  /***/
  | SetUserAndBgDBAndReleaseLockAndThenAcquireLockAndThenSyncReceiveCount
  | AcquireUserDBLockAndThenSyncReceiveCount
  | SyncReceiveCountAndThenReleaseLock
  | SyncReceiveCountSuccessAndThenReleaseLock
  | UpdateUserDBAndSyncVendorsToBctxCombinationDataAndThenReleaseLock
  | SyncVendorsToBctxCombinationDataSuccessAndThenReleaseLock
  /***/
  | AcquireUserDBLockAndSavePendingWork
  | SavePendingWorkAndThenReleaseLock
  | UpdateUserDBAndReleaseLockAndThenRedirectToLandingPage
  | AcquireUserDBLockAndSaveEvent
  | SaveSendEventkAndThenReleaseLock
  | SaveReceiveEventkAndThenReleaseLock
  | UpdateUserDBAndReleaseLockAndSynEventsAndRedirectToLandingPage
  | AcquireUserDBLockAndThenSyncTransactions
  | SyncSendTransactionsAndThenReleaseLock
  | SyncReceiveTransactionsAndThenReleaseLock
  | SyncTransactionsSuccessAndThenReleaseLock
  /***/
  | ReleaseUserDBLock
  | ReleaseBgDBLock
  | UpdateLockDetails
  | UpdateBgDBLockDetails
  | AcquireBgDBLockAndThenSyncEvents
  | SyncEventsAndThenReleaseBgDBLock
  /***/
  | UpdateBulkCountAppBackgroundDB
  | UpdateBgDBAndReleaseLockForSyncEvents
  /***/
  | CheckStationOrShiftChange
  | BulkCountAppNoAction
  | AcquireUserDBLockAndUndoWashingSendEvent
  | AcquireUserDBLockAndUndoWashingReceiveEvent
  | SetUserDBAndBgDBAndReleaseLocksWithChainsForWashing;
